module.exports = __webpack_public_path__ + "fonts/sourcesansproitalic.2e9e0989.ttf";